import { http, createConfig } from 'wagmi';
import { injected, walletConnect } from 'wagmi/connectors';
import { mainnet, arbitrum, avalanche, gnosis, sonic, unichain, optimism, bsc, base } from 'wagmi/chains';

// Map supported networks to wagmi chains
const supportedChains = [
  mainnet,
  bsc,
  arbitrum,
  optimism,
  base,
  avalanche,
  gnosis,
  sonic,
  unichain
] as const;

const projectId = '4fabbb08785434ce039cd2e135a3f7ae';

export const wagmiConfig = createConfig({
  chains: supportedChains,
  connectors: [
    injected(),
    walletConnect({
      projectId,
      showQrModal: true,
      metadata: {
        name: 'OneTapSell',
        description: 'One Tap Sell Application - Sell all your tokens at once',
        url: typeof window !== 'undefined' ? window.location.origin : 'https://onetapsell.com',
        icons: ['/favicon.ico']
      },
      relayUrl: 'wss://relay.walletconnect.com'
    }),
  ],
  transports: {
    [mainnet.id]: http(),
    [bsc.id]: http(),
    [arbitrum.id]: http(),
    [optimism.id]: http(),
    [avalanche.id]: http(),
    [base.id]: http(),
    [gnosis.id]: http(),
    [sonic.id]: http(),
    [unichain.id]: http(),
  },
});

